var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatFileErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4773 1.44197L19.746 14.0571C19.906 14.4336 19.976 14.7398 19.996 15.0579C20.036 15.8011 19.776 16.5234 19.2661 17.0793C18.7562 17.6332 18.0663 17.9602 17.3164 17.9999H2.6789C2.36896 17.9811 2.05901 17.9107 1.76906 17.8017C0.319302 17.2171 -0.380581 15.5722 0.20932 14.1463L7.52809 1.43305C7.77804 0.986156 8.15798 0.600696 8.6279 0.352972C9.98767 -0.401102 11.7174 0.0943474 12.4773 1.44197ZM10.8675 9.7556C10.8675 10.2312 10.4776 10.6286 9.99767 10.6286C9.51775 10.6286 9.11782 10.2312 9.11782 9.7556V6.95235C9.11782 6.47573 9.51775 6.09027 9.99767 6.09027C10.4776 6.09027 10.8675 6.47573 10.8675 6.95235V9.7556ZM9.99767 14.0175C9.51775 14.0175 9.11782 13.6201 9.11782 13.1455C9.11782 12.6688 9.51775 12.2725 9.99767 12.2725C10.4776 12.2725 10.8675 12.6599 10.8675 13.1346C10.8675 13.6201 10.4776 14.0175 9.99767 14.0175Z",
    fill: "#EB001B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFileErrorIcon);
export default __webpack_public_path__ + "static/media/chatFileErrorIcon.8323d425.svg";
export { ForwardRef as ReactComponent };